import { useSelector } from 'react-redux';

import IUserGet from 'api/interfaces/users/IUserGet';
import hasPermissionType from './hasPermissionType';

/**
 * The current user has the permission, e.g. write_contacts. A user with only the read
 * permission (read_contacts) sees the pages without the buttons that change anything.
 */
const useHasPermission = (permissionType: string): boolean => {
  const currentUser = useSelector(
    (state: { users: { current: IUserGet | null } }) => state.users.current
  );

  return hasPermissionType(currentUser, permissionType);
};

export default useHasPermission;
